import { render, staticRenderFns } from "./BuildingSocietyIncorporationEscalations.vue?vue&type=template&id=66cdd874&scoped=true&"
import script from "./BuildingSocietyIncorporationEscalations.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyIncorporationEscalations.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyIncorporationEscalations.vue?vue&type=style&index=0&id=66cdd874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cdd874",
  null
  
)

export default component.exports